/* eslint-disable */
import { observer } from "mobx-react-lite";
import { ReactElement, useState } from "react";
import * as React from "react";
import { useStore } from "../../../../stores/root-store-context";
import Note, { NoteType } from "./Note";
import { Button, Pagination, Select } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import styles from "./notes.module.scss";
import { useIsNarrow } from "Components/TableMui/ResponsiveGrid";
import dayjs from "dayjs";

const Notes = observer((props: {}): ReactElement => {
  const { ricStore, applicationStore } = useStore();
  const isNarrow = useIsNarrow(576);
  const numEachPage = 10;
  // Local-only draft note (not yet POSTed). Rendered above the list; persisted
  // on Save, discarded on Cancel.
  const [draftNote, setDraftNote] = useState<NoteType | null>(null);
  const [current, setCurrent] = useState<number>(1);
  const [minValue, setMinValue] = useState<number>(0);
  const [maxValue, setMaxValue] = useState<number>(10);
  const [typeFilter, setTypeFilter] = useState<string>("All");
  const [categoryFilter, setCategoryFilter] = useState<string>("All");
  const handleChange = (value: number): void => {
    setCurrent(value);
    setMinValue((value - 1) * numEachPage);
    setMaxValue(value * numEachPage);
  };

  // Builds an in-memory draft note (no backend call). Persisted only on Save.
  const buildDraftNote = (): NoteType =>
    ({
      writeAccess: true,
      accountNumber: ricStore.accountInformation?.accountNumber ?? "",
      NoteID: "",
      opened: dayjs(),
      openedStr: "",
      openedBy: applicationStore?.userEmployee,
      openEmployeeKey:
        applicationStore?.userEmployee?.employeeKey?.toString() ?? "",
      closed: dayjs(),
      closedStr: "",
      created: "",
      closedBy: undefined,
      assignedTo: undefined,
      closeEmployeeKey: "",
      category1: "",
      category2: null,
      noteText: "",
      resolution: "",
      // Default Type pre-selected on a new note, matching the previous
      // (backend createNote) behavior.
      Type: "Web Contract Update",
      contact: "",
      fileName: "",
      fileUrl: "",
      onWeb: "No",
      responsibleEmployeeKey: "",
      binaryFile: null,
      isFile: false,
      isNew: true,
      isDraft: true,
    } as unknown as NoteType);

  return (
    <div className="ric-pane">
      <div className="ric-toolbar">
        <div className="ric-toolbar__field">
          <span>Type</span>
          <Select
            className={styles.filterSelect}
            data-testid="ric-notes-type-select"
            defaultValue={typeFilter}
            onChange={(value: string) => {
              setTypeFilter(value);
              handleChange(1);
            }}
            options={[
              { value: "All", label: "All" },
              ...[
                ...ricStore.notesInformation.reduce(
                  (types, obj) => (types.add(obj.Type), types),
                  new Set<string>()
                ),
              ].map((el, index) => ({ value: el, label: el })),
            ]}
          />
        </div>
        <div className="ric-toolbar__field">
          <span>Category 1</span>
          <Select
            className={styles.filterSelect}
            data-testid="ric-notes-category-select"
            defaultValue={categoryFilter}
            onChange={(value: string) => {
              setCategoryFilter(value);
              handleChange(1);
            }}
            options={[
              { value: "All", label: "All" },
              ...ricStore.category1Items
                .filter((category1) => {
                  return ricStore.notesInformation.some(
                    (note) => note.category1 === category1
                  );
                })
                .map((el, index) => {
                  return { value: el, label: el };
                }),
            ]}
          />
        </div>
        <div className="ric-toolbar__action">
          <Button
            data-testid="ric-add-note-btn"
            className={styles.addNoteButton}
            disabled={!ricStore.isEditable}
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setDraftNote(buildDraftNote())}
          >
            Click to Add a Note
          </Button>
        </div>
      </div>
      {draftNote && (
        <Note
          key="draft-note"
          item={draftNote}
          isDraft
          onCancel={() => setDraftNote(null)}
          onSaved={() => setDraftNote(null)}
        />
      )}
      {ricStore.notesInformation
        .filter((el) => {
          return (
            (typeFilter === "All" || el.Type === typeFilter) &&
            (categoryFilter === "All" || el.category1 === categoryFilter)
          );
        })
        ?.slice(minValue, maxValue)
        ?.map((item: NoteType, index: number) => {
         item.noteText =
    ["undefined", "null", null, undefined].includes(item?.noteText as any)
      ? ""
      : item.noteText;
          return (
            <Note key={item.NoteID} item={item} />
          );
        })}
      <div className="ric-notes__pager">
        <Pagination
          showSizeChanger={false}
          showLessItems={isNarrow}
          defaultCurrent={1}
          current={current}
          onChange={handleChange}
          total={
            ricStore.notesInformation.filter((el) => {
              return (
                (typeFilter === "All" || el.Type === typeFilter) &&
                (categoryFilter === "All" || el.category1 === categoryFilter)
              );
            })?.length
          }
        />
      </div>
    </div>
  );
});
export default Notes;
